if(window.innerWidth <= 768) {
  const slidesToRemove = document.querySelectorAll('.homepageSlider .hidden-md-down');

  slidesToRemove.forEach(item => {
    item.remove();
  })
}

const slickSettings = {
  responsive: [
    {
      breakpoint: 9999,
      settings: 'unslick',
    },
    {
      breakpoint: 769,
      settings: {
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: false,
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

$('.homepageSlider').slick(slickSettings);